import React, { cloneElement, useState } from 'react'
import classNames from 'classnames'
import { CSSTransition } from 'react-transition-group'
import { ModalTransitionProps } from './ModalTransition.types'
import css from './ModalTransition.styles.scss'

const CLASSES = {
  enter: css['ModalTransition--enter'],
  enterDone: css['ModalTransition--enter-done'],
  exit: css['ModalTransition--exit'],
  exitDone: css['ModalTransition--exit-done'],
}

const ModalTransition: React.FC<ModalTransitionProps> = ({
  children,
  in: isOpen,
  timeout = 300,
  type,
}) => {
  /*
    Handling the transition class with callbacks allows persistence of the value for
    stateClass between renders. This is necessary to avoid the class being reset when
    viewing dimensions change.
  */
  const [stateClass, setStateClass] = useState(CLASSES.exitDone)
  const childrenWithProps = cloneElement(children, {
    className: classNames(
      children.props.className,
      css[`ModalTransition__${type}`],
      css.ModalTransition__child,
      stateClass
    ),
  })

  return (
    <CSSTransition
      mountOnEnter
      unmountOnExit
      appear={isOpen}
      in={isOpen}
      timeout={timeout}
      onEnter={() => setStateClass(CLASSES.enter)}
      onEntered={() => setStateClass(CLASSES.enterDone)}
      onExit={() => setStateClass(CLASSES.exit)}
      onExited={() => setStateClass(CLASSES.exitDone)}
    >
      {childrenWithProps}
    </CSSTransition>
  )
}

export default ModalTransition
